import clsx, { type ClassValue } from 'clsx'

/**
 * Concaténation conditionnelle de classes.
 *
 * Volontairement sans `tailwind-merge` : les primitives d'interface exposent des
 * variantes fermées plutôt que d'accepter n'importe quelle classe en surcharge.
 * Si une variante manque, on l'ajoute au composant — on ne la bricole pas depuis
 * l'appelant. C'est ce qui garde la charte tenable sur 47 écrans.
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}
